
import {typesReguserdet} from './svtypes/reguserdet'

//const {typesReguserdet} = require('./svtypes/reguserdet')


/*
//http://svabode-1420502022.us-west-1.elb.amazonaws.com/account/addressDetail
//POST http://localhost:8080/account/addressDetail
http://localhost:8086/account/addressDetail
rq
{
 "id":3
}



*/
let initStore = {
    loading: false,
    error: false,
    my_data_geo:{
        "countryTypes": [
            {
                "name": "United STates America",
                "a2": "US",
                "a3": "USA",
                "value": "USA",
                "isonum": "840"
            },
            {
                "name": "Canada",
                "isdcode": "01",
                "a2": "CA",
                "a3": "CAN",
                "value": "CAN",
                "isonum": "124"
            }
        ],
        "stateTypes": [
            {
                "name": "California",
                "value": "CA",
                "a2": "CA"
            },
            {
                "name": "New York",
                "value": "NY",
                "a2": "NY"
            },
            {
                "name": "Texas",
                "value": "TX",
                "a2": "TX"
            }
        ],
        "isdcodeTypes": [
            {
                "name": "United States Of America(+1)",
                "value": "1"
            },
            {
                "name": "Australia(+61)",
                "value": "61"
            },
            {
                "name": "Spain(+34)",
                "value": "34"
            }
        ],
        "genderTypes": [
            {
                "name": "CL_MALE",
                "value": "MALE"
            },
            {
                "name": "CL_FEMALE",
                "value": "FEMALE"
            }
        ]
    },
    my_data_reguserdet: {
        "id": -11,
        "fname": "",
        "lname": "",
        "email": "",
        "username": "",
        "password": "",
        "passwordmirror": "pet123",
        "isdcode": "+1",
        "encpassword": "",
        "phone": ""
    }
   
}

export default (state = initStore, action) => {
    console.log(action);
    let januState;
    switch (action.type) {
        case 'GET_REGUSERGEO_SUCCESS':
            console.log("reduce  MON23SV %%%%%%%% typesReguserdet.GET_REGUSERGEO_SUCCESS my_data_geo  success*****************");
            console.log(action.payload.my_data_geo);
            januState = {...state, loading: false, my_data_geo: action.payload.my_data_geo}
 
            // let januState = {...state, loading: false, my_data_reguserdet: action.payload.my_data_reguserdet}
            return januState
        
        case "GET_REGUSERDET_SUCCESS":
            console.log("reducer MON23SV GET_REGUSERDET_SUCCESS success*****************");
            console.log(action.payload.my_data_reguserdet);
            // let januState = {...state, loading: false, my_data_reguserdet: action.payload.my_data_reguserdet}
             januState = {...state, loading: false, my_data_reguserdet: action.payload.my_data_reguserdet}
            return januState
        
        case typesReguserdet.GET_REGUSERDET_SUCCESS:
            console.log("reduce %%%%%%%%evsearcg  success*****************");
            console.log(action.payload.my_data_reguserdet);
            // let januState = {...state, loading: false, my_data_reguserdet: action.payload.my_data_reguserdet}
             januState = {...state, loading: false, my_data_reguserdet: action.payload.my_data_reguserdet}
            return januState
        case typesReguserdet.GET_REGUSERDET_LOGOUT:
                console.log("logout")
                januState = {...state, loading: false, my_data_profile: action.payload.my_data_profile}
                return januState
       
        case "GET_SAVEREGUSER_BEGIN":
            console.log("loading")
            return {...state, loading: true}
        case "GET_SAVEREGUSER_ERROR":
            console.log("error")
            return {...state, error: true}
        case "GET_CUSTOM_USERCREDDET_SUCCESS":
                console.log("reduce %%%%%%%%evsearcg  success*****************");
                console.log(action.payload.my_data_profile);
                // let januState = {...state, loading: false, my_data_usercreddet: action.payload.my_data_usercreddet}
                 januState = {...state, loading: false, my_data_profile: action.payload.my_data_profile}
                return januState
        
        default:
            return state
    }
}